export default __webpack_public_path__ + "static/media/face_compare_two.35da4b1f.jpg";